import {
  isNotUndefined_default
} from "./chunk-ZNK2UXVC.mjs";

// src/monet-utils/verifyEither.ts
import {
  Left,
  Right
} from "monet";
import { match, when } from "ts-pattern";
function verifyEither(x) {
  return match(x).with({ map: when(isNotUndefined_default) }, (_val) => _val).with(
    { "@@type": "monet.js/Either" },
    (_val) => match(_val).with({ isRightValue: true }, (y) => Right(y.value)).with({ isRightValue: false }, (y) => Left(y.value)).run()
  ).run();
}
var verifyEither_default = verifyEither;

export {
  verifyEither_default
};
//# sourceMappingURL=chunk-F55FDC7O.mjs.map